import { useQuery } from '@tanstack/react-query'
import { hsCodeApi } from '@/modules/hs/api/api'


export const useHsChapter = () => {
  return useQuery({
    queryKey: ['hscode', 'chapter'],
    queryFn: hsCodeApi.getChapter,
    retry: 1,
  })
}